export default __webpack_public_path__ + "static/media/new-q2link-white.068ac956.svg";